import styled from 'styled-components';

export const SolutionsContainer = styled.div`
  .offer-txt-head p {
    color: #ffffff;
    font-size: 18px;
    letter-spacing: 0.2px;
    line-height: 28px;
    max-width: 410px;
  }

  .offer-txt-head p span {
    width: 99px;
    height: 1px;
    background-color: #fff;
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
  }

  .solution-offser-single {
    min-height: 536px;
    background-position: center;
    background-size: cover;
    position: relative;
    padding: 22px;
  }

  .solution-rotate-txt {
    position: absolute;
    left: 30px;
    top: 30px;
    color: #ffffff;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 2.9px;
    line-height: 15px;
    writing-mode: vertical-lr;
    transform: rotate(180deg);
    padding-bottom: 35px;

    span {
      display: inline-block;
      position: absolute;
      bottom: 0;
      left: 0;
      height: 22px;
      width: 2px;
      background-color: #fff;
      margin-left: 5px;
    }
  }

  .solution-offer-area {
    padding: 40px 0 500px;
  }
  .offer-solution-main {
    padding: 30px 0 0;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: calc(50% + 130px);
      opacity: 0.1;
      background-color: #fafafa;
      height: 50%;
      width: 43%;
    }
  }

  .solution-video-area {
    margin-top: -320px;
    padding: 10px;
    position: relative;
  }

  .build-project {
    &-block {
      margin-top: 20px;
    }

    &-main {
      padding: 80px 0 150px;

      h2 {
        color: #0a090b;
        font-size: 33px;
        font-weight: bold;
        letter-spacing: -0.24px;
        line-height: 46px;
        text-align: center;
      }
    }

    &-subhead {
      color: #0a090b;
      font-size: 16px;
      letter-spacing: -0.12px;
      line-height: 30px;
      text-align: center;
    }

    &-single {
      display: block;
      text-align: center;
      padding: 45px 0;

      * {
        color: ${({ theme: { colors } }) => colors.darkGrey};
        transition: all 0.3s ease-in-out;
      }

      h4 {
        font-family: Vollkorn, sans-serif;
        font-size: 32px;
        letter-spacing: -0.24px;
        line-height: 37px;
        padding-top: 40px;
      }

      p {
        font-size: 16px;
        letter-spacing: -0.12px;
        line-height: 24px;
      }

      &:hover {
        * {
          color: ${({ theme: { colors } }) => colors.pink};
        }
      }
    }
  }

  .solution-client-speak {
    padding-top: 80px;
    padding-bottom: 80px;
  }
`;
